/* This is the EMIS Contract teacher secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 72px"
        border="1px;"
        width="390px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="row-title">បុគ្គលិក</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr>
            <td class="row-title">
              គ្រូក្របខ័ណ្ឌមកពីកន្លែងផ្សេងកំពុងជួយបង្រៀន
            </td>
            <td class="row-data">
              <numberinput v-model="data.otto" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.ottf" class="number" />
            </td>
          </tr>
          <tr>
            <td class="row-title">ចំនួនគ្រូជាប់កិច្ចសន្យាកំពុងជួយបង្រៀន</td>
            <td class="row-data">
              <numberinput v-model="data.conto" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.conf" class="number" />
            </td>
          </tr>
          <tr>
            <td class="row-title">ចំនួនបុគ្គលិកពិការភាព</td>
            <td class="row-data">
              <numberinput v-model="data.dito" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.ditf" class="number" />
            </td>
          </tr>
          <!-- add 24-25 -->
          <tr>
            <td class="row-title">ចំនួនបុគ្គលិកបង្រៀនដែលលើស</td>
            <td class="row-data">
              <numberinput v-model="data.LCKTT" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.LCKFT" class="number" />
            </td>
          </tr>
          <tr>
            <td class="row-title">ចំនួនបុគ្គលិកបង្រៀនដែលខ្វះ</td>
            <td class="row-data">
              <numberinput v-model="data.OVRTT" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.OVRTF" class="number" />
            </td>
          </tr>
          <tr>
            <td class="row-title">
              ចំនួនបុគ្គលិកបង្រៀនទទួលការបណ្តុះបណ្តាលថ្នាក់បរិយាបន្ន
            </td>
            <td class="row-data">
              <numberinput v-model="data.INCTT" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.INCFT" class="number" />
            </td>
          </tr>
          <tr>
            <td class="row-title">
              បុគ្គលិកបង្រៀនបានធ្វើបច្ចុប្បន្នកម្មកិច្ចតែងការ
            </td>
            <td class="row-data">
              <numberinput v-model="data.LPLTT" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.LPLFT" class="number" />
            </td>
          </tr>
          <tr>
            <td class="row-title">
              បុគ្គលិកបង្រៀនថ្នាក់បច្ចេកទេស
            </td>
            <td class="row-data">
              <numberinput v-model="data.TELTT" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data.TELFT" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 300px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
</style>